import { render, staticRenderFns } from "./CategoryStep.vue?vue&type=template&id=70b4f86f&scoped=true&"
import script from "./CategoryStep.vue?vue&type=script&lang=js&"
export * from "./CategoryStep.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStep.vue?vue&type=style&index=0&id=70b4f86f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4f86f",
  null
  
)

export default component.exports